// Toggles for the student form pill groups (e.g. vegetarian Sí/No).
// Each group is identified by [data-pill-group="name"], with buttons carrying
// [data-pill-value] and a hidden input [data-pill-input="name"].

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-pill-group]").forEach((group) => {
    const name = group.dataset.pillGroup
    const input = document.querySelector(`input[data-pill-input='${name}']`)
    if (!input) return

    const buttons = group.querySelectorAll("[data-pill-value]")
    const activeClasses = ["bg-primary-700", "text-white"]
    const inactiveClasses = ["text-ink-muted", "hover:bg-surface", "hover:text-ink", "cursor-pointer"]

    const render = (value) => {
      buttons.forEach((btn) => {
        const isActive = btn.dataset.pillValue === String(value)
        btn.setAttribute("aria-pressed", String(isActive))
        activeClasses.forEach((cls) => btn.classList.toggle(cls, isActive))
        inactiveClasses.forEach((cls) => btn.classList.toggle(cls, !isActive))
      })
    }

    render(input.value)

    buttons.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault()
        const value = btn.dataset.pillValue
        input.value = value
        render(value)
      })
    })
  })
})
